import React from 'react';
import './Style.css';

export default function BackDrop({onClick}){ 
   	return(
      <div className="backdrop" onClick={onClick}/>
    );
}
